import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { adminClient } from '../lib/adminClient';

/**
 * Wraps admin-only routes. Verifies the buyer session AND the is_admin
 * RPC. Anonymous users go to /login; signed-in non-admins get a 403 page.
 */
const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [adminState, setAdminState] = useState('checking'); // 'checking' | 'yes' | 'no'

  useEffect(() => {
    let cancelled = false;
    if (loading) return;
    if (!user) { setAdminState('no'); return; }
    adminClient.isAdmin()
      .then((ok) => { if (!cancelled) setAdminState(ok ? 'yes' : 'no'); })
      .catch(() => { if (!cancelled) setAdminState('no'); });
    return () => { cancelled = true; };
  }, [user, loading]);

  if (loading || adminState === 'checking') {
    return (
      <div data-testid="admin-route-loading" className="flex min-h-[60vh] items-center justify-center">
        <div className="text-center">
          <div className="label-overline text-neutral-500">Verifying admin access…</div>
          <div className="mt-3 h-px w-24 mx-auto bg-neutral-300 animate-pulse" />
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  if (adminState === 'no') {
    return (
      <div data-testid="admin-forbidden" className="bg-white">
        <div className="mx-auto max-w-2xl px-5 py-24 text-center md:py-32">
          <span className="label-overline">/ Admin · 403</span>
          <h1 className="mt-4 font-display tracking-tighter" style={{ fontWeight: 700, fontSize: 'clamp(2rem,5vw,3.5rem)', lineHeight: 0.95 }}>
            Operations Center is restricted.
          </h1>
          <p className="mt-5 text-neutral-700">Your account isn't on the admin allowlist. If you should have access, ask a superadmin to add your user.</p>
          <a href="/" className="mt-8 inline-block btn-giwahs btn-giwahs-secondary">Back to platform</a>
        </div>
      </div>
    );
  }

  return children;
};

export default AdminRoute;
